<template>
    <div id="loading-wrapper">
        <div id="loading-text">
            <span class="loading-logo">
                <img :src="`${publicPath}/img/maruhide-logo.png`" class="menu-logo" id="menu-logo" alt="menu logo" />
            </span>
            <span class="route-name ml-3 d-inline-block">
                Production Control System
            </span>
        </div>
      </div>
</template>
<script>
export default {}
</script>